var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24L19.2 19.2H7.2C6.54 19.2 5.975 18.965 5.505 18.495C5.035 18.025 4.8 17.46 4.8 16.8V15.6H18C18.66 15.6 19.225 15.365 19.695 14.895C20.165 14.425 20.4 13.86 20.4 13.2V4.8H21.6C22.26 4.8 22.825 5.035 23.295 5.505C23.765 5.975 24 6.54 24 7.2V24ZM2.4 12.21L3.81 10.8H15.6V2.4H2.4V12.21ZM0 18V2.4C0 1.74 0.235 1.175 0.705 0.705C1.175 0.235 1.74 0 2.4 0H15.6C16.26 0 16.825 0.235 17.295 0.705C17.765 1.175 18 1.74 18 2.4V10.8C18 11.46 17.765 12.025 17.295 12.495C16.825 12.965 16.26 13.2 15.6 13.2H4.8L0 18Z",
    fill: "#2E3944"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsChats);
export default __webpack_public_path__ + "static/media/icons_chats.6bc1c05b.svg";
export { ForwardRef as ReactComponent };